import {
    Button, Progress,
    FormControl, FormLabel, HStack, Input,
    Modal,
    ModalBody,
    ModalCloseButton,
    ModalContent, ModalFooter,
    ModalHeader,
    ModalOverlay, Spacer,
    useToast, VStack, Box
} from "@chakra-ui/react";
import {useEffect, useState} from "react";
import {User} from "../../../Models/User";
import {QrProject} from "../../../Models/QrProject";
import {UsersAPI} from "../../../APIs/UsersAPI";
import LocalStorageService from "../../../Utils/Auth/LocalStorageService";
import {ObjectId} from "bson";
import {QrProjectsAPI} from "../../../APIs/QrProjectsAPI";
import * as React from "react";
import {readBlobText} from "@testing-library/user-event/utils/dataTransfer/Blob";

interface AddProjectModalProps {
    run: any,
    isOpen: any,
    onClose: any
}

export const AddProjectModal = ({run, isOpen, onClose}: AddProjectModalProps) => {

    const toast = useToast()
    const [user, setUser] = useState<User>();
    const [newQrProject, setNewQrProject] = useState<QrProject>();
    const [loading, setLoading] = useState<boolean>(false);

    const update_qr_project_state = (name: string, value: any) => {
        setNewQrProject(
            (prevState: any) =>
                ({...prevState,
                    [name]: value})
        );
    }

    const get_user = async () => {
        setUser(await UsersAPI.get_user_by_id(LocalStorageService.getInstance().getUser()).then())
    }

    const clear_qr_project = () => {
        setLoading(false)
        setNewQrProject({
            _id: new ObjectId(),
            name: "",
            owner: user?._id!,
            editors: []
        })
    }

    const required_info = () => {
        if (newQrProject?.name == "") {
            return false
        } else {
            return true
        }
    }

    const create_qr_project = () => {
        if (required_info()) {
            setLoading(true)
            QrProjectsAPI.create_qr_project(newQrProject!)
                .then((res) => {
                    let data = res!
                    toast({
                        title: 'Success.',
                        description: newQrProject?.name + " Created Successfully",
                        status: 'success',
                        duration: 5000,
                        isClosable: true,
                    })
                    run()
                    window.location.pathname += "/" + data._id.toString()
                })
                .catch(() => {
                    setLoading(false)
                    toast({
                        title: 'Error.',
                        description: "Qr project creation failed!",
                        status: 'error',
                        duration: 5000,
                        isClosable: true,
                    })
                })
        } else {
            toast({
                title: 'Error.',
                description: "Qr project creation failed!",
                status: 'error',
                duration: 5000,
                isClosable: true,
            })
        }
    }

    const close_modal = () => {
        setLoading(false)
        clear_qr_project()
        onClose()
    }

    useEffect(() => {
        get_user().then()
    }, [])

    useEffect(() => {
        clear_qr_project()
    }, [user])

    return(
        <>
            <Modal
                isOpen={isOpen}
                onClose={onClose}
            >
                <ModalOverlay />
                <ModalContent>
                    <ModalHeader>Create a new Qr Project</ModalHeader>
                    <ModalCloseButton />

                    <ModalBody>
                        <VStack>
                            <FormControl
                                id="name"
                                isRequired
                            >
                                <FormLabel>Project Name</FormLabel>
                                <Input
                                    placeholder='i.e. Discounts Qr Collection'
                                    value={newQrProject?.name}
                                    onChange={(value) => {
                                        update_qr_project_state(value.target.id, value.target.value)
                                    }
                                    }
                                    autoFocus={true}/>
                            </FormControl>
                            <Spacer/>
                            { loading ?
                                <Box width={"100%"}>
                                    <Progress
                                        isIndeterminate={loading}
                                        colorScheme={"red"}
                                    />
                                </Box>
                                :
                                <></>
                            }
                        </VStack>
                    </ModalBody>

                    <ModalFooter>

                        <VStack>
                            <HStack>
                                <Spacer/>
                                <Button
                                    onClick={close_modal}
                                >
                                    Cancel
                                </Button>
                                <Button
                                    bgGradient="linear(to-r, brand.300, brand.200)"
                                    isDisabled={!required_info()}
                                    variant='solid'
                                    onClick={create_qr_project}
                                    isLoading={loading}
                                    _hover={{
                                        bg: "brand.200",
                                    }}
                                >
                                    Create Project
                                </Button>
                            </HStack>
                        </VStack>
                    </ModalFooter>
                </ModalContent>
            </Modal>
        </>
    )
}